import PropTypes from 'prop-types';
import { createFragmentContainer, graphql } from 'react-relay/legacy.js';
import { CreatorsSidebar } from './CreatorsSidebar.jsx';
import { CreatorsContent } from './CreatorsContent.jsx';
import styles from './styles/CreatorsWrapper.module.css';

function CreatorsWrapperComponent({ nationality, style, vertical, viewer }) {
    return (
        <div className={styles.wrapper}>
            <CreatorsSidebar
                nationality={nationality}
                style={style}
                vertical={vertical}
                viewer={viewer}
            />
            <CreatorsContent
                nationality={nationality}
                style={style}
                vertical={vertical}
                viewer={viewer}
            />
        </div>
    );
}

CreatorsWrapperComponent.propTypes = {
    nationality: PropTypes.string,
    style: PropTypes.string,
    vertical: PropTypes.string.isRequired,
    viewer: PropTypes.object.isRequired,
};

export const CreatorsWrapper = createFragmentContainer(CreatorsWrapperComponent, {
    viewer: graphql`
        fragment CreatorsWrapper_viewer on Viewer {
            ...CreatorsContent_viewer
            ...CreatorsSidebar_viewer
        }
    `,
});
